<template>
  <div class="message">
    <div class="info">
      <div class="top">
        <router-link to="/">首页</router-link>>留言咨询
      </div>
      <div class="contentinfo">
        <div class="title">
          <h4>在线留言</h4>
          <p>欢迎您的到来!您的每一条意见，我们都会认真对待。</p>
        </div>
        <div class="form">
          <el-form label-width="80px">
            <el-form-item required label="称呼">
              <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item required label="联系方式">
              <el-input v-model="form.phone"></el-input>
            </el-form-item>
            <el-form-item required label="留言内容">
              <el-input type="textarea" :rows="4" v-model="form.content"></el-input>
            </el-form-item>
          </el-form>
          <el-button @click="submitForm()">提交</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { leaveMessages } from '@/request/sacinfo'
export default {
  name: "Message",
  components: {
  },
  data() {
    return {
      form: {
        name: '',
        phone: '',
        content: ''
      }
    }
  },
  mounted() {
  },
  methods: {
    submitForm() {
      if (this.form.name.length > 10) {
        this.$message.error("称呼不能超过10个字");
        return;
      }
      if (!/^\d{7,11}/.test(this.form.phone)) {
        this.$message.error("请输入正确的联系方式");
        return;
      }
      console.log(this.form.content);
      if (!this.form.content) {
        this.$message.error("请输入留言内容");
        return;
      }
      leaveMessages(this.form).then(() => {
        this.form = {};
        this.$message.success({ message: "留言成功", offset: 100 });
      });
    }
  }
};
</script>
<style scoped>
.message {
  position: relative;
  width: 100%;
  background-color: #fff;
}
.info {
  position: relative;
  width: 1200px;
  height: 1245px;
  margin: 0 auto;
  overflow: hidden;
}
.info>.top {
  position: relative;
  margin-top: 27px;
  height: 14px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
  line-height: 14px;
}
.info>.contentinfo{
  position: relative;
  margin-top: 41px;
  margin-left:209px;
  padding: 0 51px 0 33px;
  width: 783px;
  height: 645px;
  background: linear-gradient(39deg, rgba(247, 248, 255, 0.46), rgba(248, 248, 248, 0.46));
  box-shadow: 0px 0px 12px 0px rgba(32, 58, 102, 0.17);
  display: flex;
  flex-direction: column;
  justify-content: start;
}
.info>.contentinfo>.title{
  position: relative;
  margin-top: 42px;
  font-family: PingFang SC;
  text-align: center;
}
.info>.contentinfo>.title>h4{
  position: relative;
  width: 783px;
  height: 18px;
  font-size: 18px;
  font-weight: bold;
  color: #333333;
  line-height: 18px;
}
.info>.contentinfo>.title>p{
  position: relative;
  margin: 18px 0 58px;
  width: 783px;
  height: 14px;
  font-size: 14px;
  font-weight: 500;
  color: #999999;
  line-height: 14px;
}
.form /deep/ .el-button{
  position: relative;
  margin-top: 31px;
  margin-left: 243px;
  width: 297px;
  height: 54px;
  background: #306BCD;
  border-radius: 5px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #FFFFFF;
}
.form /deep/ .el-form-item{
  margin-bottom: 36px;
}
</style>
